var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ArticleLayout',{staticClass:"privacy-policy-container",attrs:{"title":"PRICACY POLICY"}},[_c('iframe',{attrs:{"src":"/pdfjs/web/viewer.html?file=/privacy-policy.pdf"}})])}
var staticRenderFns = []

export { render, staticRenderFns }